import { Component } from '@angular/core';
import { LoaderHandlerService } from 'src/app/shared/services/loader-handler.service';

@Component({
  selector: 'app-full-loader',
  templateUrl: './full-loader.component.html',
  styleUrls: ['./full-loader.component.scss']
})
export class FullLoaderComponent {

  isLoading$ = this.loaderService.isLoading$;
  loadingMessage$ = this.loaderService.loadingMessage$;

  constructor(
    public loaderService: LoaderHandlerService
  ) { }

}
